import { useEffect, useRef } from "react";
import { useSubNavigationPortal } from "@components/mainInterface/SubNavigationPortal";

export const useSubNavigationPortalContent = (
    id: string,
    content: React.ReactNode,
) => {
    const { registerPortal, unregisterPortal } = useSubNavigationPortal();
    const isRegistered = useRef(false);
    const lastContentRef = useRef<React.ReactNode>(null);

    useEffect(() => {
        // Only register if content exists and is different from last content
        if (content && content !== lastContentRef.current) {
            registerPortal(id, content);
            isRegistered.current = true;
            lastContentRef.current = content;
        } else if (!content && isRegistered.current) {
            // Unregister if content is null/undefined and we were previously registered
            unregisterPortal(id);
            isRegistered.current = false;
            lastContentRef.current = null;
        }

        return () => {
            if (isRegistered.current) {
                unregisterPortal(id);
                isRegistered.current = false;
                lastContentRef.current = null;
            }
        };
    }, [id, content, registerPortal, unregisterPortal]);

    return { isRegistered: isRegistered.current };
};
